/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Diff_EmptyInputs */

const cs_ebr_diff_empty = /** @type {(inputs: Ebr_Diff_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(prázdné)`)
};

const en_ebr_diff_empty = /** @type {(inputs: Ebr_Diff_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(empty)`)
};

/**
* | output |
* | --- |
* | "(empty)" |
*
* @param {Ebr_Diff_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_empty = /** @type {((inputs?: Ebr_Diff_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_empty(inputs)
	return cs_ebr_diff_empty(inputs)
});